import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import Select from '../Select'
import { useSelectionSet } from '../../hooks/selection-set-functions'

const SelectArbitraggio = () => {
  const availableArbitraggi = useSelector(
    state => state.selection.availableArbitraggi,
  )
  const selectedArbitraggio = useSelector(
    state => state.selection.selectedArbitraggio,
  )

  const { setSelectedArbitraggio } = useSelectionSet()

  const value = availableArbitraggi?.includes(selectedArbitraggio)
    ? selectedArbitraggio
    : undefined

  return (
    <Grid size={{ xs: 12, md: 2 }}>
      <Select
        id='available-arbitraggi'
        label='Arbitraggio'
        value={value}
        options={availableArbitraggi}
        disabled={!availableArbitraggi}
        onChange={setSelectedArbitraggio}
      />
    </Grid>
  )
}

export default SelectArbitraggio
